
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { db, storageRef, auth } from '@/main'
import mixin from '@/mixin'
import axios from 'axios'
import { URL_CLOUD_FUNCTIONS } from '@/firebase/init'
@Component
export default class CreateAdminDialog extends mixins(mixin) {
  showDialog = false
  adminNames = ''
  adminLastNames = ''
  adminEmail = ''

  selectedImage: File = new File([''], '')

  rulesImage = [
    (v) => (v != undefined ? !!v || 'La imagen es obligatorio' : ''),
    (v) =>
      !v ||
      v.size < 2000000 ||
      'El tamaño de la imagen debe ser menor de 2 MB!',
  ]

  onSelectedImageChange(val) {
    console.log(val)
    this.selectedImage = val
  }

  clearFields() {
    this.showDialog = false
    this.adminNames = ''
    this.adminLastNames = ''
    this.adminEmail = ''
    this.selectedImage = new File([''], '')
  }

  validateEmail(email) {
    return /\S+@\S+\.\S+/.test(email)
  }

  async createAdmin() {
    if (this.adminNames == '' || this.adminLastNames == '') {
      this.showNotification(
        'fail',
        'Error',
        'Debes agregar los nombres y apellidos. Intenta nuevamente'
      )
    } else if (this.adminEmail == '') {
      this.showNotification(
        'fail',
        'Error',
        'Debes agregar el correo. Intenta nuevamente'
      )
    } else if (!this.validateEmail(this.adminEmail)) {
      this.showNotification(
        'fail',
        'Error',
        'Debes agregar un correo válido. Intenta nuevamente'
      )
    } else {
      const list = await auth.fetchSignInMethodsForEmail(this.adminEmail)

      if (list.length == 0) {
        console.log('Vacia')
        const newAdmin = {
          type: 'ADMINISTRADOR',
          enable: true,
          profile_info: {
            names: this.adminNames,
            last_names: this.adminLastNames,
            image: '',
            email: this.adminEmail,
          },
          permissions: {
            admin: {
              icon: 'supervisor_account',
              position: 2,
              route: '/admin',
              status: true,
              text: 'Administrador',
            },
            dashboard: {
              icon: 'dashboard',
              position: 1,
              route: '/dashboard-admin',
              status: true,
              text: 'Dashboard',
            },
            users: {
              icon: 'supervised_user_circle',
              position: 3,
              route: '/users-admin',
              status: true,
              text: 'Usuarios',
            },
             settings: {
              icon: 'fas fa-cogs',
              position: 4,
              route: '/settings',
              status: true,
              text: 'Configuración',
            },
          },
        }
        if (this.selectedImage != null && this.selectedImage.name != '') {
          const docRef = db.collection('admins').doc()
          const refId = docRef.id

          this.showNotification(
            'loading',
            'Subiendo',
            'Subiendo foto del administrador'
          )
          const uploadTask = await storageRef
            .child('admins/' + refId + '/profile_image')
            .put(this.selectedImage)
          newAdmin.profile_info.image = await uploadTask.ref.getDownloadURL()
        }

        this.showNotification(
          'loading',
          'Creando administrador',
          'Un momento por favor'
        )
        const url = URL_CLOUD_FUNCTIONS + 'createAdmin'

        try {
          const resp = await axios.post(url, newAdmin)
          console.log(resp)
          this.showNotification(
            'success',
            'Administrador creado',
            'El administrador fue creado con éxito'
          )
          this.clearFields()
        } catch (error) {
          this.showNotification(
            'fail',
            'Error',
            'No se pudo crear el administrador. Intenta nuevamente'
          )
          console.log(error)
          this.showDialog = false
        }
      } else {
        this.showNotification(
          'fail',
          'Error',
          'El correo ingresado ya se encuentra registrado. Intenta nuevamente'
        )
      }
    }
  }
}
